"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPreviousJagdJahr = exports.getCurrentJagdJahr = void 0;
/**
 * Function that returns the start and end Dates of the current hunting season
 * in Germany this is 01.04.x -> 31.03.x + 1
 *
 * @returns {start: Date, end: Date}
 */
const getCurrentJagdJahr = () => {
    const startString = `-04-01T00:00:00`;
    const endString = `-03-31T23:59:59`;
    const now = new Date();
    const year = now.getFullYear(); // eg. 2021
    const month = now.getMonth(); // 0-11
    if (month < 3) {
        // meaning start in last year
        return { start: new Date(`${year - 1}${startString}`), end: new Date(`${year}${endString}`) };
    }
    else {
        return { start: new Date(`${year}${startString}`), end: new Date(`${year + 1}${endString}`) };
    }
};
exports.getCurrentJagdJahr = getCurrentJagdJahr;
/**
 * Function that returns the start and end Dates of the previous hunting season
 * in Germany this is 01.04.x -> 31.03.x + 1
 *
 * @returns {start: Date, end: Date}
 */
const getPreviousJagdJahr = () => {
    const startString = `-04-01T00:00:00`;
    const endString = `-03-31T23:59:59`;
    const now = new Date();
    const year = now.getFullYear(); // eg. 2021
    const month = now.getMonth(); // 0-11
    if (month < 3) {
        // meaning start in last year
        return { start: new Date(`${year - 2}${startString}`), end: new Date(`${year - 1}${endString}`) };
    }
    else {
        return { start: new Date(`${year - 1}${startString}`), end: new Date(`${year}${endString}`) };
    }
};
exports.getPreviousJagdJahr = getPreviousJagdJahr;
